import S, { DataSignal } from 's-js';
import { Typeahead } from 'portcall/typeahead/model';
import { CaseInsensitiveContains } from 'lib/diacriticals';
import escapeHtml from 'lib/escapeHtml';
import { PCUser} from 'data/models/PCUser';
import { Organization } from 'data/models/Organization';

export interface UserSelectorParams {
    UserId? : DataSignal<number>
    Users : () => PCUser[]
}

export function UserSelector(opts : UserSelectorParams) {
    const userId      = opts.UserId ||  S.data(0),
        users       = opts.Users,
        initialUser = S.sample<PCUser | undefined>(() => users().find(u => u.Id() === userId()));
    
    const query =  S.data(initialUser ? S.sample(() => initialUser.FullName()) : ''),
        typeahead = new Typeahead<PCUser>({
            collection: users,
            typeaheadOptions: {
                minLength: 0,
                highlight: true,
                hint: false
            },
            observable: query,
            matchFn: (user : PCUser, query : string) => 
                CaseInsensitiveContains(user.FullName(), query) 
                    || user.Organization() !== null && CaseInsensitiveContains(user.Organization() && user.Organization()!.Name() || '', query),
            displayKey: u => u.FullName(),
            templates: {
                suggestion: formatSuggestion,
                footer: formatFooter
            },
            onSelect: u => userId(u.Id())
        });

    let lastOrg : Organization | null = null;
        
    return typeahead;
    
    function formatSuggestion(user : PCUser) {
        var header = '',
            item = '<div class="user">' + escapeHtml(user.FullName()) + '</div>';
        
        if (user.Organization() && user.Organization() !== lastOrg) {
            header = '<div class="org">' + escapeHtml(user.Organization()!.Name()) + "</div>";
        }
        
        lastOrg = user.Organization();
        
        return header + item;
    }
    
    function formatFooter() {
        lastOrg = null;
        return '';
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/userselector/model.ts